import { HttpErrorStatusCodes, InternalHandledErrorTypes, FriendlyErrorMessage } from '../types'

export const errorTypesForStatusCodes: Map<HttpErrorStatusCodes, InternalHandledErrorTypes> =
  new Map([
    [HttpErrorStatusCodes.BadRequest, InternalHandledErrorTypes.InvalidData],
    [HttpErrorStatusCodes.Unauthorized, InternalHandledErrorTypes.Authentication],
    [HttpErrorStatusCodes.Forbidden, InternalHandledErrorTypes.Authorization],
    [HttpErrorStatusCodes.NotFound, InternalHandledErrorTypes.NotFound],
    [HttpErrorStatusCodes.InternalServerError, InternalHandledErrorTypes.Unknown],
    [HttpErrorStatusCodes.ServiceUnavailable, InternalHandledErrorTypes.ServiceUnavailable],
  ])

export const errorMessagesForErrorTypes: Map<InternalHandledErrorTypes, FriendlyErrorMessage> =
  new Map([
    [
      InternalHandledErrorTypes.Unknown,
      {
        title: 'Houve um erro inesperado',
        description: 'Não foi possível completar sua requisição. Tente novamente.',
      },
    ],
    [
      InternalHandledErrorTypes.InvalidData,
      {
        title: 'Dados inválidos',
        description:
          'Os dados enviados pela sua requisição são inválidos. Contate o suporte caso acredite que este seja um engano.',
      },
    ],
    [
      InternalHandledErrorTypes.Authentication,
      {
        title: 'Não autenticado',
        description:
          'Parece que você não está autenticado e por isso não foi possível completar sua requisição. Recarregue a página e tente novamente.',
      },
    ],
    [
      InternalHandledErrorTypes.Authorization,
      {
        title: 'Não autorizado',
        description: 'Você não está autorizado a performar esta ação.',
      },
    ],
    [
      InternalHandledErrorTypes.NotFound,
      {
        title: 'Recurso não encontrado',
        description: 'O recurso que você procura não foi encontrado.',
      },
    ],
    [
      InternalHandledErrorTypes.ServiceUnavailable,
      {
        title: 'Serviços temporariamente indisponíveis',
        description:
          'Nossos serviços não foram capazes de atender à sua requisição neste momento. Tente novamente mais tarde.',
      },
    ],
  ])
